import template from './month_date_select.html.slim';
import controller from './month_date_select_controller';

angular.module('wbComponents').directive('wbMonthDateSelect', () =>
  ({
    restrict: 'E',
    replace: true,
    scope: {
      range: '=?',
      date: '=?',
      startDate: '=?',
      endDate: '=?'
    },
    templateUrl: template,
    transclude: true,
    controller,
    controllerAs: 'ctrl',
    bindToController: true,
    link($scope, $el, $attrs) {
      $scope.ctrl.isRange = ($attrs.range != null);
      return $scope.ctrl.isDate = ($attrs.date != null);
    }
  })
);
